// extracted by mini-css-extract-plugin
export default {"logos":"styles-module__logos___kJU_O","logo":"styles-module__logo___c0noA"};